import './../../external/@lit/reactive-element/reactive-element.js';
import { html as y } from './../../external/lit-html/lit-html.js';
import { LitElement as s } from './../../external/lit-element/lit-element.js';
import LanguageSwitcherCss from "./LanguageSwitcherCss.js";
class LanguageSwitcher extends s {
  static get styles() {
    return [LanguageSwitcherCss];
  }
  static get EVENT_KEYS() {
    return {
      LANGUAGE_CHANGED: "change-language"
    };
  }
  render() {
    return y`
      <ul>
        ${iscecoWidgetLibrary.supportedLanguages.map((language) => this._renderLanguage(language))}
      </ul>
    `;
  }
  _renderLanguage(language) {
    const isActive = getLanguage() === language;
    return y`
      <li class="${isActive ? "active" : ""}"
          @click="${(e) => isActive ? e.stopPropagation() : this._changeLanguage(language)}">
        ${language.toUpperCase()}
      </li>
    `;
  }
  _changeLanguage(language) {
    setLanguage(language);
    send(LanguageSwitcher.EVENT_KEYS.LANGUAGE_CHANGED);
    this.requestUpdate();
  }
}
customElements.define("isceco-language", LanguageSwitcher);
export { LanguageSwitcher as default };
